export enum PAYROLL_ACCOUNT_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  UNKNOWN = 'UNKNOWN',
}

export enum BUSINESS_ENTITY_WIZARD_KEYS {
  ONBOARDING = 'ONBOARDING',
  ADD_BUSINESS_ENTITY = 'ADD_BUSINESS_ENTITY',
}

export const ABN_LENGTH = 11;

export const PAYROLL_PARTNER_IDENTIFIERS = {
  Microkeeper: 'Microkeeper',
  MicrokeeperBeta: 'MicrokeeperBeta',
};

export const PAYROLL_PARTNER_BASE_URLS = {
  [PAYROLL_PARTNER_IDENTIFIERS.Microkeeper]: 'https://microkeeper.com.au',
  [PAYROLL_PARTNER_IDENTIFIERS.MicrokeeperBeta]:
    'https://beta.microkeeper.com.au',
};

export const MICROKEEPER_ROUTES = {
  NAVIGATION_ROUTES: {
    GETTING_STARTED: {
      name: 'getting-started',
      path: '',
    },
    PAY_RUNS: {
      name: 'pay-runs',
      path: 'payruns.php',
    },
    SUPERANNUATION: {
      name: 'superannuation',
      path: 'super.php',
    },
    REPORTS: {
      name: 'reports',
      path: 'reports.php',
    },
    SUPERANNUATION_SETTINGS: {
      name: 'super-annuation-settings',
      path: 'settings_general.php?section=super',
    },
    DEDUCTIONS_SETTINGS: {
      name: 'deductions-settings',
      path: 'ded_exp_rules.php',
    },
    EXTRA_EARNINGS_SETTINGS: {
      name: 'extra-earnings-settings',
      path: 'extra_rules.php',
    },
    LEAVE_ENTITLEMENT_SETTINGS: {
      name: 'leave-entitlement-settings',
      path: 'settings_general.php?section=entitlement',
    },
  },
};

export enum PAYROLL_PERMISSIONS {
  Can_Setup_Initial_Payroll = 'Can_Setup_Initial_Payroll',
  Can_Add_Business_Entity = 'Can_Add_Business_Entity',
  Can_Edit_Business_Entity = 'Can_Edit_Business_Entity',
  Can_View_Pay_Business_Setting = 'Can_View_Pay_Business_Setting',
  Can_View_Pay_Calendar = 'Can_View_Pay_Calendar',
  Can_Manage_Pay_Calendar = 'Can_Manage_Pay_Calendar',
  Can_Manage_Payroll = 'Can_Manage_Payroll',
  Can_Manage_Payroll_In_Partner = 'Can_Manage_Payroll_In_Partner',
  Can_Manage_Employee_PayDetails = 'Can_Manage_Employee_PayDetails', // permission for pay details (bank, super, TFN sections)
  Can_Manage_Emp_Payroll_Details = 'Can_Manage_Emp_Payroll_Details', // permission for payroll details (payroll-calculation, recent-payslips)
}

export const PAYROLL_GETTING_STARTED_DISMISSED =
  'PAYROLL_GETTING_STARTED_DISMISSED';

export enum LEAVE_EXTENSION_STATUS {
  // tenant has no leave extension
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  // tenant has leave extension and successfully disabled it
  DISABLE_SUCCESS = 'DISABLE_SUCCESS',
  // tenant has leave extension but failed to disable it
  DISABLE_FAILED = 'DISABLE_FAILED',
}

export enum PAYROLL_ROLE_SETUP_STATUS {
  ROLE_SETUP_NOT_APPLICABLE = 'ROLE_SETUP_NOT_APPLICABLE',
  ROLE_SETUP_SUCCESS = 'ROLE_SETUP_SUCCESS',
  ROLE_SETUP_FAILED = 'ROLE_SETUP_FAILED',
}
